import { Injectable } from '@angular/core';
import { Api } from '../api';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { ISendEmailNotification } from './interfaces/send-email-notification.interface';
import { Observable } from 'rxjs';
import { IEmailNotification } from './interfaces/email-notification.interface';
import { IHistoryNotification } from './interfaces/history-notification.interface';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends Api {

  constructor(
    readonly http: HttpClient,
    readonly authService: AuthService
  ) {
    super(http, authService, 'notification');
  }

  sendMail(options: ISendEmailNotification): Observable<IEmailNotification> {
    return super.post(options, '/email') as Observable<IEmailNotification>;
  }

  history(): Observable<IHistoryNotification[] | any[]> {
    return super.get('/history');
  }
}
